import { Hotkey } from "../../../../../../ui/hotkey/component.js";
import { PlaybackHotkeys } from "../playback-hotkeys.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//#region src/internal/skins/shared/skins/shared/video/hotkeys.tsx
/** @jsxImportSource react */
function VideoHotkeys({ disabled = false } = {}) {
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx(PlaybackHotkeys, { disabled }),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "f",
			action: "toggleFullscreen"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "c",
			action: "toggleSubtitles"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "i",
			action: "togglePictureInPicture"
		})
	] });
}
//#endregion
export { VideoHotkeys };

//# sourceMappingURL=hotkeys.js.map